import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '@core/service';
import { EmailRegExp } from '@shared/constants';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'userCredentialsInternal',
    standalone: false
})
export class UserCredentialsInternalPipe implements PipeTransform {

  constructor(private authenticationService: AuthenticationService) { }

  transform(value: any): Observable<string> {
    if (!(value && EmailRegExp.test(value))) {
      return of(value);
    }

    return this.authenticationService.getUserClinicalCredentialsByEmail(value).pipe(
      map(credentials => {
        if (!credentials || credentials.isExternal) {
          return value;
        }

        return [credentials.firstName, credentials.lastName].filter(Boolean).join(' ') || value;
      })
    );
  }

}
